import TabNav from './TabNav';
export { TabNav };
export default TabNav;
